import Icon from 'veui/components/Icon'

Icon.register({
  'chevron-double-down': {
    raw: '<g fill="none" fill-rule="evenodd"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M44 24L24 44 4 24"/><path d="M44 5L24 25 4 5"/></g><path d="M2.59 22.59a2 2 0 012.82 0L24 41.17 42.59 22.6a2 2 0 012.82 2.82l-20 20a2 2 0 01-2.82 0l-20-20a2 2 0 010-2.82zm0-19a2 2 0 012.82 0L24 22.17 42.59 3.6a2 2 0 012.81 2.8l-20 20a2 2 0 01-2.82 0l-20-20a2 2 0 010-2.82z" fill="currentColor" fill-rule="nonzero"/></g>',
    width: '48',
    height: '48'
  }
})
